import CaseDocuments from './CaseDocuments'

export default CaseDocuments
